export default "__VITE_ASSET__sDqaBYgQ__"